import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { DynamicFieldsAPI, FormAPI, Metadata } from '@philips-internal/oswald-ui-components';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';
import BaseController from '../BaseController';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { FragmentNames,  QuizQuestionAnswerViewAliases } from '../../codegen';
import { Value } from '@philips-internal/oswald-ui-core';

const CONTEXT_VARIABLES = {
  DYNAMIC_METADATA: 'dynamicMetada',
  QUESTION_TYPE: 'questionType',
  READ_ONLY: 'readOnly',
  SEQ_AGE_INT: 'seqAgeInt',
  SEQ_AGE_INT_ITEM: 'nrSeqAgendaIntItem',
  TRANSFER: 'transfer',
  USER_NAME: 'userName',
}

const QuizItemType = {
  RADIO_GROUP: 'G'
}

@Controller({ component: QuizQuestionAnswerViewAliases.QUIZ_QUESTION_ANSWER_VIEW_LAYOUT, fragment: FragmentNames.QUIZ_QUESTION_ANSWER_VIEW })
export default class QuizQuestionAnswerViewController extends BaseController {

  @Inject(QuizQuestionAnswerViewAliases.DYNAMIC_FIELDS_FETCH_QUIZ_QUESTION_ANSWER_VIEW)
    questionnaireDynamicFieldsAPI!: DynamicFieldsAPI;

  @Inject(QuizQuestionAnswerViewAliases.FORM_FETCH_QUIZ_QUESTION_ANSWER_VIEW)
    questionnaireFormAPI!: FormAPI;

  private dynamicMetada!: Metadata;

  @OnMount({target: QuizQuestionAnswerViewAliases.DYNAMIC_FIELDS_FETCH_QUIZ_QUESTION_ANSWER_VIEW})
  handleMountDynamicFields(): void {
    this.questionnaireFormAPI.setLoading(true);

    const params = {
      nrSeqAgendaIntItem: this.context.get( CONTEXT_VARIABLES.SEQ_AGE_INT_ITEM),
      readOnly: this.context.get( CONTEXT_VARIABLES.READ_ONLY),
      seqAgeInt: this.context.get( CONTEXT_VARIABLES.SEQ_AGE_INT),
    }

    void HttpService.get<Metadata>(APPLICATION_ENDPOINTS.GET_QUIZ_METADATA, params)
      .then(response => {
        this.dynamicMetada = response.body as Metadata;
        this.questionnaireDynamicFieldsAPI.setMetadata(this.dynamicMetada);

        HttpService.get(APPLICATION_ENDPOINTS.GET_QUIZ_ANWSER_METADATA, params).then(anwser=> {
          const record: Record<string,Value> = {}
          const bodyAnwser = anwser.body as unknown as Record<string, Value> [];

          if(bodyAnwser.length === 0){
            return;
          }

          bodyAnwser.forEach(data => {
            const key = data.sequenceStructure as string;

            record[key] = this.formatAnswer(data);
          });

          this.questionnaireFormAPI.setRecord(record);
          this.questionnaireFormAPI.setLoading(false);
        })
      });
  }

  private formatAnswer = (data: Record<string, Value>): Value =>{
    if(data.typeAnswer === QuizItemType.RADIO_GROUP){
      return {key: data.sequenceAnswer?.toString()};
    }

    return data.answerGrid;
  }
}

